import { mdiInformationOutline } from "@mdi/js";
import Icon from "@mdi/react";
import { observer } from "mobx-react";
import React from "react";
import USWDS from 'uswds/src/js/components';
import './tooltipStyle.scss';

/**
 * When an instance of this component will be included in a snapshot test, 
 * you must overwrite the id provided to the tooltip box added by uswds.
 * Subsequent tests will fail as the id and aria-describedby will change on each run.
 * You can do so with the following code where idProp is the id passed in the component props:
 *  const tooltipButton = screen.getByTestId(`test-${idProp}}`);
    tooltipButton.setAttribute('aria-describedby', 'info');
    tooltipButton.nextElementSibling?.setAttribute('id', 'info');
 */

const { tooltip } = USWDS;


export type TooltipDirections = 'top' | 'bottom' | 'left' | 'right';

interface InformationTooltipProps {
    tooltipMessage: string;
    tooltipSide: TooltipDirections;
    id: string;
    extraClass?: string;
}

/**
 * Common component for displaying a tooltip via a ( i ) icon button.
 * @param props must pass a tooltipMessage for the content, tooltipSide for where the tooltip will appear, and an id
 * @returns 
 */
const InformationTooltipContainer = (props: InformationTooltipProps) => {
    React.useEffect(() => {
        tooltip.on();
      })
    return (
            <button
                className={"tooltip-button-container usa-button usa-button--unstyled usa-tooltip " + props.extraClass}
                data-position={props.tooltipSide}
                title={props.tooltipMessage}
                data-testid={'test-' + props.id}
                id={props.id}
            >
                <Icon className="information-tooltip-icon" path={mdiInformationOutline} size={1} />
            </button>
    )
}

export const InformationTooltip = observer(InformationTooltipContainer);